import React, { useCallback } from 'react'
import styled from 'styled-components'
import clss from 'classnames'

const SwitchStyled = styled.div`
  width: 48px;
  height: 24px;
  border-radius: 16px;
  position: relative;
  cursor: pointer;
  background: #3A3939;
  &.close {
    .circle{
      background: #6B6B6B;
    transform: translateX(0);
    }
  }
  .circle{
    position: absolute;
    transition: all 0.2s ease-out;
    width: 18px;
    height: 18px;
    background: #E0C286;
    mix-blend-mode: normal;
    border-radius: 100%;
    box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.08);
    top: 3px;
    left: 3px;
    transform: translateX(23px)
  }
`
type SwitchProps = {
  value: boolean
  onChange: (val: boolean) => void
}
const Switch = ({ value, onChange }: SwitchProps) => {

  const handleSwitch = useCallback(() => {
    onChange && onChange(!value)
  }, [onChange, value])

  return (
    <SwitchStyled className={clss({ 'close': !value }, 'switch')} onClick={handleSwitch} >
      <div className="circle"></div>
    </SwitchStyled>
  )
}

export default Switch